import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { TransactionActionEnum, TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';

export default function* watchExportGoldTransactionListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldExportGoldTransactionListingAttempt', handleExportGoldTransactionListing, api);
}

function* handleExportGoldTransactionListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        filters: {
            action,
            status,
            name,
            idNo,
            dateFrom,
            dateTo,
            branchName,
        },
    } = reduxState.gold.buyAndSellGold.transactionListing;

    const allBranches = reduxState.branch.allBranches;

    const branchCode = allBranches.find(branch => branch.branchName === branchName)?.branchCode;

    const response = yield* call([api, api.exportGoldTransactionListingNoTimeout], {
        authToken,
        action: action ? UtilFunctions.Misc.getEnumValueByKey(TransactionActionEnum, action) : undefined,
        status: status ? UtilFunctions.Misc.getEnumValueByKey(TransactionStatusEnum, status) : undefined,
        name: name ? name : undefined,
        idNo: idNo ? idNo : undefined,
        dateFrom: dateFrom ? dateFrom : undefined,
        dateTo: dateTo ? dateTo : undefined,
        branchCode: branchCode ? branchCode : undefined,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldExportGoldTransactionListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldExportGoldTransactionListingSuccess(response.data));
    }
}
